import EmailVerifyModal from 'User/js/mixin/email.verify.modal';
import Impressions from 'Site/js/util/impressions';
import SearchFiltersForm from 'Site/js/mixin/search.filters.form';
import store from 'Site/js/store';
import Vue from 'vue';
import { mapState } from 'vuex';
import FilterSelector from 'Site/component/FilterSelector.vue';
import galleryFilters from '../store/galleryFilters';
import GalleryResults from '../../component/GalleryResults.vue';

store.registerModule('galleryFilters', galleryFilters);

function getSetMapper(map) {
    const filters = {};
    map.forEach((key) => {
        filters[key] = {
            get() { return store.state.galleryFilters.filters[key]; },
            set(value) { store.commit('galleryFilters/SET_FILTER', { key, value }); }
        };
    });
    return filters;
}

export default function () {
    new Vue({ /* eslint no-new: 0 */
        el: '#page-body',
        name: 'galleryPage',
        store,
        mixins: [EmailVerifyModal, SearchFiltersForm],
        data() {
            return {
                accountTypes: [],
                orientationBtnTriggered: false,
                selectedAccounts: []
            };
        },
        components: {
            FilterSelector,
            GalleryResults
        },
        computed: {
            ...mapState({
                isMobile: state => state.isMobile,
                myMatches: state => state.config.data.myMatches,
                siteOrientationIds: state => state.config.data.accountTypes,
                t: state => state.t
            }),
            ...getSetMapper([
                'attitude',
                'asset',
                'behaviour',
                'build',
                'characterType',
                'childrenHave',
                'childrenLike',
                'distance',
                'dob',
                'drink',
                'ethnicity',
                'employment',
                'extra',
                'hair',
                'hairColour',
                'height',
                'location',
                'materialistic',
                'orientation',
                'personality',
                'region',
                'relationship',
                'religion',
                'smoke',
                'socialClass',
                'sort',
                'transport',
                'type'
            ]),
            allOrientationTypes() {
                return [
                    {
                        id: 'f',
                        ori: ['100', '200', '300', '400'],
                        active: false,
                        title: this.t.profile.female,
                        icons: ['female']
                    },
                    {
                        id: 'm',
                        ori: ['110', '210', '310', '410'],
                        active: false,
                        title: this.t.profile.male,
                        icons: ['male']
                    },
                    {
                        id: 'fm',
                        ori: ['110100', '300110', '310100', '400110', '410100', '410400', '410300', '310300', '400310'],
                        active: false,
                        title: this.t.profile.couple,
                        icons: ['female', 'male']
                    },
                    {
                        id: 'ff',
                        ori: ['200200', '400200', '300200', '400400', '400300', '300300'],
                        active: false,
                        title: this.t.profile.female_couple,
                        icons: ['female', 'female']
                    },
                    {
                        id: 'mm',
                        ori: ['210210', '410210', '310210', '410410', '410310', '310310'],
                        active: false,
                        title: this.t.profile.male_couple,
                        icons: ['male', 'male']
                    }
                ];
            }
        },
        methods: {
            storeReset() {
                this.$store.commit('galleryFilters/RESET_FILTERS');
            },
            resetOrientation() {
                this.accountTypes.forEach((type) => { type.active = false; });
                this.selectedAccounts = [];
            },
            setStoreFilters(filters) {
                this.$store.commit('galleryFilters/SET_FILTER', filters);
                this.$nextTick(() => {
                    this.mediaImpressions.getImpressions();
                });
            },
            // @todo setup profile presets (in profile.js)
            galleryPresets(preset) {
                this.presetSelected = true;
                this.accountTypes.forEach((type) => { type.active = false; });
                this.selectedAccounts = [];
                this.preset = preset;
                let presetFilters = {
                    sort: 'created'
                };
                if (preset === 'mine') {
                    presetFilters = Object.assign(this.myMatches);
                }
                this.$store.commit('galleryFilters/RESET_FILTERS', presetFilters);
            },
            orientationSelector(selectedId) {
                this.orientationBtnTriggered = true;
                const index = this.selectedAccounts.indexOf(selectedId);
                if (index !== -1) {
                    this.accountTypes.forEach((accountType) => {
                        if (accountType.id === selectedId) {
                            accountType.active = false;
                        }
                    });
                    this.selectedAccounts.splice(index, 1);
                } else {
                    this.selectedAccounts.push(selectedId);
                }
                const includeAccountTypes = this.accountTypes.filter(accountType => this.selectedAccounts.filter(id => accountType.id === id).length);
                includeAccountTypes.forEach((accountType) => {
                    accountType.active = true;
                });
                const oriValues = [];
                includeAccountTypes.map(accountType => accountType.ori.forEach(val => oriValues.push(val)));
                this.setFilters({ key: 'orientation', value: oriValues });
            },
            updateOrientation() {
                const orientationValues = this.orientation;
                this.accountTypes.forEach((account) => { account.active = false; });
                this.selectedAccounts = [];
                if (orientationValues.length) {
                    /*  eslint arrow-body-style:0 */
                    const filteredAccountTypes = this.accountTypes.filter((eachAccount) => {
                        return orientationValues.filter(value => eachAccount.ori.indexOf(value) !== -1).length;
                    });
                    filteredAccountTypes.forEach((accountType) => {
                        if (this.selectedAccounts.indexOf(accountType.id) === -1) {
                            accountType.active = true;
                            this.selectedAccounts.push(accountType.id);
                        }
                    });
                }
            },
            mediaType(type) {
                // type = Photos | Videos
                this.setFilters({ key: 'type', value: type });
            },
            existsCheck(value) {
                // Check if media type is already selected
                return this.type.indexOf(value) !== -1;
            }
        },
        beforeCreate() {
            // capture init state so reset will go to correct state
            this.$store.commit('galleryFilters/CAPTURE_FILTERS');
        },
        mounted() {
            this.$nextTick(() => {
                this.mediaImpressions = new Impressions('.impress-image', 'Gallery');
            });
            this.accountTypes = this.allOrientationTypes.filter(orientation => this.siteOrientationIds.filter(id => orientation.id === id).length);
        },
        watch: {
            '$store.state.galleryFilters.filters.orientation': function watchOrientation() {
                if (!this.orientationBtnTriggered) {
                    this.updateOrientation();
                }
                this.orientationBtnTriggered = false;
            }
        }
    });
}
